import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/reset-password/resetPassword')({
  beforeLoad: () => {
    const searchParams = new URL(window.location.href).searchParams;
    const token = searchParams.get('token');

    throw redirect({
      to: '/auth/reset-password',
      replace: true,
      search: {
        token: token ?? '',
      },
    });
  },
});
